module.exports = __webpack_public_path__ + "static/media/table5-city.33cb589a.png";